import React, { useState } from 'react';
import { Modal, Table, Button } from 'react-bootstrap';
import FormatCurrency from '../sistema/formatCurrency';
import { faBoxOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function ProdutosPedidoModal ({
  produtos
}) {
  const [modalShow, setModalShow] = useState(false);
  return (
    <>
      <Button
        title='Detalhes dos produtos do pedido'
        className='detail-button-index'
        onClick={() => setModalShow(true)}
      >
        <FontAwesomeIcon icon={faBoxOpen} />
      </Button>
      <Modal
        centered
        size='lg'
        show={modalShow}
        onHide={() => setModalShow(false)}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header
          closeButton={true}
          className="qr-code-modal-header"
        >
          <Modal.Title
            className="qr-code-modal-title"
            id="contained-modal-title-vcenter"
          >
            Produtos
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Table
              striped
              bordered
              responsive
              style={{width: '100%', margin: 0, padding: 0}}
            >
              <thead>
                <tr>
                  <th scope="col">Produto</th>
                  <th scope="col">Quantidade</th>
                  <th scope="col">Preço</th>
                  <th scope="col">Total</th>
                </tr>
              </thead>
              <tbody>
                {
                  produtos?.map(produto => {
                    return (
                      <tr key={produto.nome}>
                        <td>{produto.nome}</td>
                        <td>{produto.quantidade}</td>
                        <td><FormatCurrency number={produto.preco} /></td>
                        <td><FormatCurrency number={produto.preco * produto.quantidade} /></td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </Table>
          </Modal.Body>
      </Modal>
    </>
  )
}

export default React.memo(ProdutosPedidoModal);